import owaServiceFeatures from 'owa-service/lib/owaServiceFeatures';

// Please insert new features in alphabetical order, to preserve readability and reduce chance of merge conflicts
const features = {
    ...owaServiceFeatures,
    'addin-centerAlignedICSEnabled': {},
    'addin-complianceVerification': {},
    'addin-delegateAccess': {},
    'addin-getAccessTokenAsync-api': {},
    'addin-inClientStoreDefaultAddinsEnabled': {},
    'addin-inClientStoreEnabled': {},
    'addin-inClientStorePinnableExperience': {},
    'addin-inClientStoreSendFeedbackEnabled': {},
    'addin-itemSendEvent': {},
    'addin-launchDatapoint': {},
    'addin-oteljs': {},
    'addin-persistentTaskPane': {},
    'addins-launchAddinsFromUrl': {},
    'an-client-error': {},
    'an-client-event': {},
    'an-client-network-request': {},
    'an-client-verbose-wl': {},
    'an-full-logging': {},
    'an-no-sample-ppe': {},
    'an-sampled-client-event': {},
    'auth-PremiumDashboard': {},
    'auth-PremiumDashboardApril': {},
    'auth-PremiumSupportControl': {},
    'auth-PremiumSupportTreatment': {},
    'auth-ServiceWorkerEdge': {},
    'auth-ServiceWorkerSafari': {},
    'auth-activityFeed': {
        description: 'Enables the activity feed panel',
    },
    'auth-cloudCache': {},
    'auth-connectedAccounts': {},
    'auth-cutOverSoftLanding': {
        description: 'Allows the React Mail cut over FRE to be shown',
    },
    'auth-domainConnect': {},
    'auth-domainConnect-popout': {},
    'auth-domainConnectDemandGen': {},
    'auth-forwardingNotice': {
        description: 'Shows the forwarding notice toast notification at app startup',
    },
    'auth-getStarted': {},
    'auth-leftNavInAppUpsell': {},
    'auth-leftNavPremiumUpsell': {},
    'auth-leftNavPremiumUpsellNoCCTreatment': {},
    'auth-LeftNavUpsellFreeServicesTreatment': {},
    'auth-LeftNavUpsellFreeServicesControl': {},
    'auth-linkedInOption': {},
    'auth-mobileDevice': {},
    'auth-openAnotherMailbox': {
        description: 'Enables the "Open another mailbox" dialog menu item for explicit login',
    },
    'auth-realtimeEmail': {
        description: 'Enables the iris call to send marketing emails for better visibility',
    },
    'auth-safelinksOptionControl': {},
    'auth-whatsNew': {},
    'auth-whatsNew-nonPremExp': {},
    'auth-calendar-serviceworker-cache': {
        description: 'Enables the service worker cache for the calendar app.',
    },
    'cal-CalendarDayListComponent': {},
    'cal-addCalendarFromDirectory': {},
    'cal-addins': {},
    'cal-advancedRoomBooking': {},
    'cal-agendaMail-feedback': {},
    'cal-agenda': {},
    'cal-automatic-replies': {},
    'cal-birthday-settings': {},
    'cal-categories': {},
    'cal-css-variables': {},
    'cal-dimPastEvents': {},
    'cal-dnd-icsfile': {
        description:
            'Flight to enable drag and drop of ics file on calendar to lauch Discover Calendar with Import from File panel',
    },
    'cal-event-duration-setting': {},
    'cal-event-invitation-setting': {},
    'cal-getFreeBusyfromLAS': {},
    'cal-groupCalendarSetColor': {},
    'cal-groupsCalendar': {},
    'cal-ignoreSkipSendingMeetingInviteToGroup': {},
    'cal-highlightPastDays': {},
    'cal-ics-preview': {},
    'cal-assumeTzOffsetFromCalendarItem': {
        description:
            "Assumes the time zone offset in a calendar item is correct for the user's time zone.",
    },
    'cal-intelligenceOption': {
        description: 'Whether to show intelligence features in Options',
    },
    'cal-interestingCalendar': {},
    'cal-linkedCalendarEntry': {},
    'cal-locationCard': {},
    'cal-meetingInsights': {},
    'cal-mf-automatic-replies-notification': {
        description: 'Flight to enable the automatic replies notification',
    },
    'cal-mf-OnlineMeetingSummary': {},
    'cal-mf-UseUcwaForSkype': {
        description:
            'Flight to enable the call to UCWA service if defaultProvider and allowedProviders are set to null',
    },
    'cal-mf-agendaMailOption': {
        description: 'Whether to show Calendar agenda mail in Options',
    },
    'cal-mf-duplicateEvent': {
        description:
            'Flight which enables the Copy Event feature which lets the user duplicate any event from the details form',
    },
    'cal-mf-groupAttendees': {
        description:
            'Flight which enables grouping attendees according to their response status in full compose; enables showing attendees response details in calendar peek for a meeting with no more than two attendees',
    },
    'cal-mf-hideAddRoomForZeroQuery': {
        description: 'Flight to disable Add Room button in Location Well for zero query scenarios',
    },
    'cal-mf-hideAttendeeList': {
        description: 'Flight to enable showing the hide attendee list option in calendar compose',
    },
    'cal-mf-locationBusyConfirmation': {
        description:
            'Flight to pop-up a confirm dialog, on meeting updates, when the location is busy in the new time slot.',
    },
    'cal-mf-locationCommonWell': {},
    'cal-mf-locationWellInSA': {
        description: 'Flight to enable the location well in the scheduling assistant',
    },
    'cal-mf-locationWellShowFreeBusy': {
        description:
            'Flight to enable displaying LocationWell pills with a lower right icon showing FB status',
    },
    'cal-mf-locationwellSearchByCity': {
        description: 'Flight to show room suggestions based on city search.',
    },
    'cal-mf-popoutReadForm': {
        description: 'Used to open conflict calendar item in popout window from mail reading pane',
    },
    'cal-mf-proposeNewTime': {
        description:
            'Flight to enable new proposed new time experience in Mail, i.e accepting proposed new time in meeting response or proposing a new time from a meeting request from both Mail and Calendar',
    },
    'cal-mf-recipientWell': {
        description:
            'Add recipient well in Quick Compose so we can add attendees and create a meeting there',
    },
    'cal-mf-recipientWellBelowTimeInQC': {
        description: 'Put recipient well below time controls in Quick Compose',
    },
    'cal-mf-requestOnlyFreeRoomsForZeroQuery': {
        description:
            'Flight to request only Available conference rooms for zero query in Location Well',
    },
    'cal-mf-timeSuggestions': {
        description: 'Flight to show CAS suggestions in the compose form',
    },
    'cal-mf-newTimeZonePicker': {
        description: 'Replaces the plain time zone picker with a search-by-city smart field',
    },
    'cal-mf-timezoneinsights': {},
    'cal-mf-availabilityForRecurrence': {
        description: 'Flight to request free busy for recurring meetings in Location Well',
    },
    'cal-mf-defaultRoomsFromLasInRoomPanel': {
        description:
            'Flight to use LAS as the default room provider in the room panel when no filters are selected',
    },
    'cal-mf-useTenantSearch': {
        description: 'Flight to search rooms across tenant wide rooms',
    },
    'cal-mf-diagnostics': {
        description:
            'Flight to rollout logging of calendar forms diagnostics.  This flight should always be in SDF only, Otherwise we will log this unnecessarily for customers',
    },
    'cal-mf-rsvpModel': {
        description: 'Flight to show the new RSVP model (Yes/No/Maybe) underneath notes editor',
    },
    'cal-notifications-expandCalendarEvent': {},
    'cal-personalbookingpage': {},
    'cal-pbp-option': {
        description: 'Enabled personal booking page for user',
    },
    'cal-ppf-celebration': {},
    'cal-print': {},
    'cal-publishing-settings': {},
    'cal-qc-guidedCapture': {},
    'cal-qc-guidedCaptureFeedbackAutoCollection': {
        description: 'Flight to enable auto collection of feedback for model improvements',
    },
    'cal-qc-guidedCaptureBetaEndpoint': {},
    'cal-qc-guidedCaptureFullContainer': {},
    'cal-qc-guidedCaptureV2Subject': {},
    'cal-qc-moveCalendar': {},
    'cal-react': {},
    'cal-mf-recurringBookingOutOfPolicyInfoBar': {
        description:
            'Flight to show InfoBar texts to users to indicate room booking will be declines because of Out Of Window policy.',
    },
    'cal-recurrenceThisDateForward': {},
    'cal-relatedContent': {
        description: 'OWS Prime API call to fetch related content when opening details panel',
    },
    'cal-relatedContent-filesAndEmailsUX': {
        description: 'Whether to show the related files and emails inside the insights container',
    },
    'cal-schedulingAssistantAttendeeColors': {},
    'cal-schedulingAssistantGradientColors': {},
    'cal-schedulingAssistantSpacedLegend': {},
    'cal-sea-addCalendarQuickAction': {},
    'cal-sea-clientSide': {},
    'cal-sea-contextFeedback': {},
    'cal-sea-peopleQF': {},
    'cal-sea-query': {},
    'cal-sharing': {},
    'cal-sharing-settings': {},
    'cal-showRoomBookingCapabilities': {},
    'cal-splitView': {},
    'cal-stickyNotesFolder': {},
    'cal-surface-declinedMeetings': {},
    'cal-surface-discover-calendars-experiment': {},
    'cal-surface-itemExpand': {},
    'cal-surface-notificationBar': {},
    'cal-surface-refresh': {},
    'cal-surface-refresh-addCalendar': {},
    'cal-surveyCancelMeetBucket': {
        description: 'Calendar survey bucket triggered by canceling 1 meeting',
    },
    'cal-surveyCreateApptBucket': {
        description: 'Calendar survey bucket triggered by creating 2 appointments',
    },
    'cal-surveyCreateMeetBucket': {
        description: 'Calendar survey bucket triggered by creating 2 meetings',
    },
    'cal-surveyUpdateApptBucket': {
        description: 'Calendar survey bucket triggered by updating 1 appointment',
    },
    'cal-surveyUpdateMeetBucket': {
        description: 'Calendar survey bucket triggered by updating 2 meetings',
    },
    'cal-surveyViewEventBucket': {
        description:
            'Calendar survey bucket triggered by viewing 2 events via details, peek, or meeting card',
    },
    'cal-txp-editableCard': {},
    'cal-txp-emailDonation': {},
    'cal-txp-griffin': {},
    'cal-txp-inferencesDSAT': {},
    'cal-txp-invoice': {},
    'cal-txp-optionsV2': {},
    'cal-txp-serviceReservation': {},
    'cal-weather-addLocations': {},
    'cmp-accChecker': {},
    'cmp-asyncSelect': {
        description:
            'Queues select changes in editor core before updating document in a requestAnimationFrame. Will not work in webkit until undoPlugin is updated to not break selection in webkit.',
    },
    'cmp-darkMode': {
        description: 'Enables the dark compose experience.',
    },
    'cmp-darkModeToggle': {
        description:
            'Exposes a dark mode toggle to switch the editor between dark mode and light mode.',
    },
    'cmp-delaySend': {
        description: 'Enables the Delay/Undo send feature',
    },
    'cmp-dictation': {
        description: 'Flag to turn on dictation in compose',
    },
    'cmp-dlExpandPerf': {
        description: 'Flag to turn on the perf of DL expansion in compose section',
    },
    'cmp-downgradeRawCED': {
        description: 'Downgrade editor to raw CED for debugging',
    },
    'cmp-editorPerfMeasure': {
        description: 'Measure the perf of editor in compose',
    },
    'cmp-encryption': {},
    'cmp-fabricRecipientWell': {},
    'cmp-clp': {
        description:
            'Whether the clp is enable by tenant. When flag is enabled, each email will be given a sensitivity level and the encryption is applied through labeling instead of the RMS Templates',
    },
    'cmp-hipCheckModal': {
        description:
            'Whether or not to use a modal for the hip check instead of a tab (spam suspicion / account verification)',
    },
    'cmp-hipCheckVendorModal': {
        description: 'Whether the cmp-hipCheckModal should be provided by a vendor',
    },
    'cmp-hipCheckChallengeOnSendFail': {
        description:
            'Whether the cmp-hipCheckModal should be presented immediately on wascl send failure',
    },
    'cmp-implicitgroups': {
        description: 'Implicit group suggestion in mail compose find control',
    },
    'cmp-logOnFrameDropWhileTyping': {
        description: 'Log a datapoint on when a frame is dropped while typing',
    },
    'cmp-mailtips': {},
    'cmp-manageIRM': {
        description: 'Enabled the UI to manage the IRM template applied to a message',
    },
    'cmp-mutationObserverReactEditorIE11': {
        description:
            'Use MutationObserver in IE11 ReactEditor to set isDirty, since it does not send input events in contentEditable divs',
    },
    'cmp-newEmoji-plugin': {
        description: 'Refactored and rewritten emoji picker and corpus, sourced from roosterJS',
    },
    'cmp-policyTips': {
        description:
            'Enables the fetching of, managing of, and displaying of policyTips for enterprise.',
    },
    'cmp-quickSwitcher': {
        description: 'Toolbar for moving quickly between areas of the app and running commands',
    },
    // TODO #33638 This is for a mail feature, but has to be in client-controls because it is used in
    // CustomSurfaceAction, which does not support a client repo adding additional custom surface actions.
    'cmp-requestDeliveryReceipts': {
        description: 'Toggles whether the UI for requesting Delivery Receipts is shown',
    },
    // TODO #33638 This is for a mail feature, but has to be in client-controls because it is used in
    // CustomSurfaceAction, which does not support a client repo adding additional custom surface actions.
    'cmp-requestReadReceipts': {
        description: 'Toggles whether the UI for requesting Read Receipts is shown',
    },
    'cmp-ribbonBIUS': {
        description: 'Places strikethrough with Bold, Italic, and Underline',
    },
    'cmp-ribbonRemoveFormatAtFront': {
        description: 'Places Remove Format at the front of the ribbon with Format Painter',
    },
    'cmp-ribbonStickyUndo': {
        description:
            'Always display undo as the last non-overflow item on the compose editor ribbon',
    },
    'cmp-selfAsYou': {},
    'cmp-setMessageSensitivity': {
        description: 'Toggles whether the UI for setting message sensitivity is shown',
    },
    'cmp-smime': { description: 'Toggles whether S/MIME feature is enabled in compose form' },
    'cmp-smimeAdminSettings': {
        description: 'Toggles whether S/MIME admin/user settings is respected in compose form',
    },
    'cmp-upgradeCompose': {
        description: 'Loads the editor before retrieving the quoted body in compose',
    },
    'doc-attachment-composeDropHint': {},
    'doc-attachment-contextualSharingTips': {},
    'doc-attachment-convertClassicToCloudy': {},
    'doc-attachment-convertCloudyToClassic': {},
    'doc-attachment-convoWell': {},
    'doc-attachment-docLinksProperty': {},
    'doc-attachment-documentThumbnail': {},
    'doc-attachment-downloadDomain': {},
    'doc-attachment-dragDropAttachments': {},
    'doc-attachment-expiringLinkImprovements': {},
    'doc-attachment-referenceAttachmentExpiration': {},
    'doc-attachment-includeMostRecentAttachments': {},
    'doc-attachment-sharingDialog': {},
    'doc-attachment-sharingInfoFailureTip': {},
    'doc-attachment-sharingLinkInfoOWSPrimeService': {},
    'doc-attachment-sharingTips': {},
    'doc-recipient-permission': {},
    'doc-attachment-upsellEntryPoint': {},
    'doc-brandsSubscriptions': {},
    'doc-filePicker-groupFiles': {},
    'doc-filePicker-mailMessageAttachment': {},
    'doc-filePicker-mailMessageSearch': {},
    'doc-filePicker-oneDriveConsumerForO365': {},
    'doc-filePicker-oneDriveProClientCalls': {},
    'doc-filePicker-oneDriveProRecentFiles': {},
    'doc-filepicker-preload': {},
    'doc-filePicker-sharedWithMeImprovements': {},
    'doc-filePicker-thirdPartyProviderClientCalls': {},
    'doc-fileProvider-facebook': {},
    'doc-fileProvider-wopiClient': {},
    'doc-fileshub': {},
    'doc-SharePoint-dogfoodUser': {},
    'doc-sharepoint-link-preview': {},
    'doc-sharepoint-serviceGeneratedLinkTelemetry': {},
    'doc-SxS-commandBarStyleUpdate': {},
    'doc-SxS-itemAttachment': {},
    'doc-SxS-jsApi-ODB-Core': {},
    'doc-SxS-jsApi-ODB-Word': {},
    'doc-SxS-jsApi-ODB-Excel': {},
    'doc-SxS-jsApi-ODB-PowerPoint': {},
    'doc-SxS-pdfJsPreview': {},
    'doc-SxS-pdfJsPreviewDefaultInEdge': {},
    'doc-SxS-pdfJsPreviewDefaultInFirefox': {},
    'doc-SxS-printImage': {},
    'doc-SxS-printPdf': {},
    'doc-SxS-refactor': {},
    'doc-SxS-saveToCloud': {},
    'doc-SxS-V2': {},
    'ext-timeExpressionHighlight': {},
    'feedback-ideas-pane': {},
    'fms-dialog': {},
    'fms-dialog-action': {},
    'fwk-ads': {},
    'fwk-ads-detectAdBlocker': {},
    'fwk-ads-disableDefaultPG': {},
    'fwk-ads-disableFallback': {},
    'fwk-ads-exp2-RuntimeBypass': {},
    'fwk-ads-exp2-StopStampUserOption': {},
    'fwk-ads-exp2-DisplayOffNativeOff': {},
    'fwk-ads-exp2-DisplayOffNativeOther': {},
    'fwk-ads-exp2-DisplayOffNativeInbox': {},
    'fwk-ads-exp2-DisplayOnNativeOff': {},
    'fwk-ads-exp2-DisplayOnNativeOther': {},
    'fwk-ads-exp2-DisplayOnNativeInbox': {},
    'fwk-ads-exp2-ByPassNewUserCheck': {},
    'fwk-ads-programmatic-br': {},
    'fwk-ads-programmatic-none': {},
    'fwk-ads-removeUpsell': {},
    'fwk-ads-upgradeUpsell': {},
    'fwk-batchSubscriptions': {},
    'fwk-bookingsModule': {},
    'fwk-cobranding': {},
    'fwk-consumerWaffle': {},
    'fwk-darkTheme': {},
    'fwk-devTools': {},
    'fwk-emptyPost': {},
    'fwk-errorHandlerNonWrapped': {},
    'fwk-errorpopup': {},
    'fwk-exportMailboxOption': {},
    'fwk-feedbackCharm': {},
    'fwk-fluentFabric': {},
    'fwk-gdprAdsPrefs': {},
    'fwk-getAllowedOptions': {
        description:
            'Flight to indicate whether to call GetAllowedOptions to determine what options to show or hide.',
    },
    'fwk-hipExceptionRedirect': {},
    'fwk-improvedExceptionHandler': {},
    'fwk-inAppNotifications': {},
    'fwk-localeHotReload': {},
    'fwk-moduleSwitcherReuseTab-all': {},
    'fwk-moduleSwitcherReuseTabs': {},
    'fwk-nativeAds-appNexusOneClick': {},
    'fwk-nativeAds-appNexusOneClickOtherInboxOnly': {},
    'fwk-nativeAds-appNexusTwoClick': {},
    'fwk-nativeAds-bingOneClick': {},
    'fwk-nativeAds-bingOneClickForceViewTracker': {},
    'fwk-nativeAds-bingPrebid': {},
    'fwk-nativeAds-bingOneClickOtherInboxOnly': {},
    'fwk-nativeAds-bingTwoClick': {},
    'fwk-nativeAds-bingTwoClickOtherInboxOnly': {},
    'fwk-nativeAds-honorEasyOtherOffKillSwitch': {},
    'fwk-nativeAds-prebidOneClickAllInbox': {},
    'fwk-nativeAds-prebidOneClickOtherInboxOnly': {},
    'fwk-nativeads-disableIcons': {},
    'fwk-nativeads-fanFillNobid': {},
    'fwk-o365shellheader': {},
    'fwk-o365shellheader-responsive': {},
    'fwk-option-popImap': {},
    'fwk-partner-code-off': {},
    'fwk-patchSignalRGetUrl': {},
    'fwk-peopleReact': {},
    'fwk-perf-fps': {},
    'fwk-performanceCharm': {},
    'fwk-politeServiceErrors': {},
    'fwk-prefetch-code-off': {},
    'fwk-prefetch-data-off': {},
    'fwk-proxyOwsPrime': {},
    'fwk-skypeBusiness': {},
    'fwk-skypeConsumer': {},
    'fwk-skypeSettingsMigration': {},
    'fwk-skypeSuite': {
        description:
            'Flight to control whether the O365 Suite Header takes control of initializing Skype',
    },
    'fwk-skypeBusinessCalling': {},
    'fwk-themes-edu': {
        description: 'Whether to show new themes to EDU tenants',
    },
    'fwk-turnOffCustomData': {},
    'fwk-useJsonNetSerializer': {},
    'fwk-webNotification': {},
    'fwk-webPushNotification': {},
    'fwk-webPushNotificationSignout': {
        description: 'Unsubscribe web push notification on explicit signout',
    },
    'fwk-webPushNotificationV2': {},
    'grp-NativeConnectorsPortalEnabled': {
        description: 'If enabled, Connectors portal will be opened in a modal',
    },
    'grp-consumerGroupFilesInGroupHub': {},
    'grp-discovery-leftnav': {
        description: 'Enables the Groups Discover workflow',
    },
    'grp-manage-leftnav': {
        description: 'Enables the Groups Hub entry',
    },
    'grp-groupFileshubFRE': {
        description: 'If enabled, shows FRE callouts in Group files hub',
    },
    'grp-groupHeaderV2': {},
    'grp-prefetchSPTokenFromConversations': {
        description: 'If enabled, prefetches token in conversation space',
    },
    'grp-screenshotAutomationTest': {},
    'grp-unreadCountTop5AndFavorites': {},
    'grp-warmUpFrequentlyUsedGroups': {},
    'gsx-translator-translateMessage': {},
    'help-disableTicketFlow': {},
    'help-miniMavenWidget': {},
    'help-o365ShellHeader-MaxPane': {},
    'help-proactiveMessaging': {},
    'lpc-isInBlackforest': {
        description: 'Indicates that the user is in a blackforest tenant',
    },
    'lpc-isInGccModerate': {
        description: 'Indicates that the user is in a GCC-moderate tenant',
    },
    'mc-botConversation': {},
    'mc-confetti': {},
    'mc-cortanaCompose': {},
    'mc-contextualSuggestionsCompose': {
        description: 'Enables making a service call for contextual suggestions in compose',
    },
    'mc-imageDiagnostics': {},
    'mc-imageSxS': {},
    'mc-logMessagesInSpanish': {
        description:
            'Temporary flight to log messages in Spanish, to see if smart reply for Spanish is a worthwhile endeavor',
    },
    'mc-moveAttachmentToInline': {},
    'mc-replyWith': {
        description: 'If enabled, we retrieve contextual attachments and MRU cloudy attachments',
    },
    'mc-replyWithNAMPrime': {
        description:
            'Equivalent to mc-replyWith, but meant for testing impact of attachment suggestions on non-NAM regions',
    },
    'mc-replyWithMRUClassic': {
        description: 'If enabled, we retrieve MRU classic attachments',
    },
    'mc-replyWithMRUCloudy': {
        description: 'If enabled we retrieve MRU cloudy attachments',
    },
    'mc-replyWithMRUCloudyLimited': {
        description:
            'If enabled, we ensure that the MRU service returns at most one cloudy attachment, the rest being classic. For testing purposes only.',
    },
    'mc-replyWithContextual': {
        description: 'If enabled, we retrieve contexutal attachment suggestions',
    },
    'mc-smartCompose': {},
    'mc-smartReplyWithDoc': {},
    'mc-smartPillsCompose': {
        description: 'Controls showing smart pills in compose',
    },
    'mc-smartPillsMessageView': {},
    'mc-smartReply': {},
    'mc-smartReplyWithCustomMeeting': {},
    'mc-smartPillConfidenceLevel_MID': {
        description: 'Enable smart-* pill when confidence score is at the mid level (ex: 80%)',
    },
    'mc-smartPillConfidenceLevel_LOW': {
        description: 'Enable smart-* pill when confidence score is low (ex: 70% or below)',
    },
    'mc-smartTodo': {
        description: 'Controls showing smart todo pills',
    },
    'mc-smartSuggestions': {},
    'mc-userHighlighting': {},
    'mc-voting': {
        description: 'Enables the owa mail voting feature',
    },
    'nps-fms': {},
    'peo-ev-header': {},
    'peo-favoritePdls': {
        description: 'Enables Private Distribution Lists favorites',
    },
    'peo-lokiDogfood': {},
    'peo-lpcTargetV2OnPersonaCardBehavior': {
        description: 'PersonaCardBehavior uses LivePersonaCardTargetV2 when this feature is on',
    },
    'peo-subjectPicker': {},
    'peo-unauthenticatedSender': {},
    'people-contactCleanupEnterprise': {},
    'people-favoritePicker': {},
    'people-favoritePickerIncludeGroups': {},
    'people-emptyFolder-bulk': {},
    'people-initialGroupsPrefetch': {},
    'people-restoreDeletedItemsFolders': {},
    'people-groupsPrefetch': {},
    'people-searchTypeLabels': {},
    'people-suggestionFolder': {},
    'people-publicFolders': {},
    'people-groupsDeeplink': {},
    'people-pdlsInCommandBar': {},
    'pf-favorite': {
        description: 'Shows public folder favorites in left-nav',
    },
    'pf-picker': {},
    'pf-picker-calendar': {},
    'pf-post': {},
    'ring-dogfood': {},
    'ring-microsoft': {},
    'ring-firstrelease': {},
    'ring-ww': {},
    'rp-3SLocalSearchRanking': {},
    'rp-3SPeopleSuggestions': {},
    'rp-acDisableTransactionCard': {
        description: 'Disables the transaction card',
    },
    'rp-acTUIBubble': {
        description: 'Adds Teaching Bubble teaching UI to Actionable Message RP',
    },
    'rp-actionableMessages': {},
    'rp-actionableMessages-aad-token': {},
    'rp-actionableMessages-contextual': {},
    'rp-actionableMessages-lpc': {},
    'rp-actionableMessages-myanalytics': {},
    'rp-actionableMessages-msa-token': {},
    'rp-adaptiveCardsRecordLinks': {
        description: 'Enables the logging of links on AdaptiveCards',
    },
    'rp-addins': {},
    'rp-amp': {},
    'rp-appendOnSend': {},
    'rp-brandCards': {},
    'rp-brandCardsUnsubscribe': {},
    'rp-brandDecorations': {},
    'rp-calendarRollup': {},
    'rp-calendarRollupDetailCard': {},
    'rp-collapsedItemsRollUp': {},
    'rp-csaExp': {},
    'rp-csaExpWithMenuIcons': {},
    'rp-customSurfaceActions': {},
    'rp-externalImagesProxyOption': {},
    'rp-findPeopleSuggestionFeedback': {},
    'rp-floatingActionBar': {},
    'rp-immersiveReader': {},
    'rp-immersiveReaderDogfood': {},
    'rp-infoBarBrandSubscription': {
        description: 'Enable Unsubscribe from Infobar',
    },
    'rp-inlineTranslation': {
        description: 'Enables inline translation of messages in reading pane',
    },
    'rp-imageApiConsumer': {},
    'rp-isSentOnBehalfOf': {},
    'rp-lastActionInfoBar': {
        description: 'Infobar to show last action of the user on an item',
    },
    'rp-like': {},
    'rp-linkedInPeopleSuggestions': {},
    'rp-showLinkedInBindingBtnInPeoplePicker': {},
    'rp-livePersonaCard': {},
    'rp-newTabLook': {
        description: 'Enabled the new tab look, including the merging of Skype and OWA tab systems',
    },
    'rp-oofRollup': {},
    'rp-opay-modelb-endpoint': {},
    'rp-outlookAddinsDeeplink': {},
    'rp-peopleSuggestionsCacheFirst': {},
    'rp-popouts': {},
    'rp-popoutsDebug': {
        description: 'When this feature is on, popout data from local storage will not be cleared',
    },
    'rp-popoutWithVersion': {
        description:
            'Try to fix 42737: Need a final solution of version mismatch between main window and popout window',
    },
    'rp-readReceipt': {
        description: 'Shows actionable infobar for user enabled read receipt',
    },
    'rp-replyByMeeting': {},
    'rp-replyImageProxy': {},
    'rp-requestPersonaResponseShape': {},
    'rp-safetyMessage': {},
    'rp-selectionUI': {},
    'rp-skypeInTabs': {
        description: 'Feature flag that controls if skype should be put into tabs managed by OWA.',
    },
    'rp-smartTime': {},
    'rp-smime': {},
    'rp-tabView': {},
    'rp-wideContent': {},
    'rp-imageContentHandler': {},
    'rp-localLieSentTime': {},
    'sea-advanced-search': {
        description:
            'If on, the revamped advanced search UI will be used to control search refiners.',
    },
    'sea-archive-mailbox-3S': {
        description: 'Search archive mailbox using 3S',
    },
    'sea-categoryClientSuggestions': {
        description: 'Shows category suggestions on search typedown',
    },
    'sea-centered': {
        description: 'Makes the search box a fixed width and centered in the header.',
    },
    'sea-centered2': {
        description: 'Iteration of center searchbox. Center aligned current theme defined opacity',
    },
    'sea-centered2-l80': {
        description: 'Iteration of center searchbox. Left aligned 80% opacity',
    },
    'sea-centered2-l90': {
        description: 'Iteration of center searchbox. Left aligned 90% opacity',
    },
    'sea-centered2-l100': {
        description: 'Iteration of center searchbox. Left aligned 100% opacity',
    },
    'sea-centered2-80': {
        description: 'Iteration of center searchbox. Center aligned 80% opacity',
    },
    'sea-centered2-90': {
        description: 'Iteration of center searchbox. Center aligned 90% opacity',
    },
    'sea-centered2-100': {
        description: 'Iteration of center searchbox. Center aligned 100% opacity',
    },
    'sea-circlePersonas': {},
    'sea-clientHitHighlight': {
        description: 'Create hit highlighting terms client side',
    },
    'sea-contextFeedback': {},
    'sea-debugHook': {},
    'sea-emailSuggestions': {
        description: 'Shows email message suggestions on search typedown',
    },
    'sea-expandThread': {
        description: 'Expand matching items of a thread in reading pane',
    },
    'sea-fileCommands': {
        description: 'Show file commands in command mode',
    },
    'sea-fileSuggestionAugmentation': {
        description: 'Show quick action buttons on file suggestions from search',
    },
    'sea-filesSuggestions': {
        description: 'Shows files suggestions on search typedown',
    },
    'sea-floodgateSurvey': {
        description: 'Floodgate survey for search scenarios',
    },
    'sea-floodgateSurveySDFSampling': {
        description: 'Floodgate survey flag to indicate SDF different sampling',
    },
    'sea-gdpr': {},
    'sea-gf': {
        description: 'Enables GF (advanced suggestions) in the search box',
    },
    'sea-gf1': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf2': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf3': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf4': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf5': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf6': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gfct1': {
        description:
            'Control flight for GF (advanced suggestions) experiment. See WI 40315 for more information about flight configuration.',
    },
    'sea-ghostText': {
        description: 'Shows ghost text in search input and allows for autocompletion.',
    },
    'sea-highlightAttachments': {
        description:
            'Highlights matching keywords in attachment names in search results (list view and RP).',
    },
    'sea-hybridSearchSupported': {
        description:
            'This flight is enabled for environments where hybrid search (for ExecuteSearch) is supported.',
    },
    'sea-initAsQuery': {},
    'sea-omitCookies': {
        description: 'Omit cookies in 3S call to improve performance',
    },
    'sea-personaAugmentation': {
        description: 'Enables /whois, /org, /meet, and corresponding icons for org and meet',
    },
    'sea-personaCardInSuggestions': {
        description: 'Shows persona card in the suggestions on hover of which we shall open LPC',
    },
    'sea-personaQueryCt': {
        description: 'from:(SMTP) OR from:("display name") / to:(SMTP) OR to:("display name")',
    },
    'sea-personaQuery1': {
        description: 'from:(SMTP) OR from:(display name) / to:(SMTP) OR to:(display name)',
    },
    'sea-personaQuery2': {
        description: 'from:"SMTP" OR from:"display name" / to:"SMTP" OR to:"display name"',
    },
    'sea-personaQuery3': {
        description: '(SMTP) OR ("display name")',
    },
    'sea-personaQuery4': {
        description: '(SMTP) OR (display name)',
    },
    'sea-personaQuery5': {
        description: '"SMTP" OR "display name"',
    },
    'sea-personaQuery6': {
        description: 'from:(SMTP) / to:(SMTP)"',
    },
    'sea-personaQuery7': {
        description: 'from:"SMTP" / to:"SMTP"',
    },
    'sea-personaQuery8': {
        description: '(SMTP)',
    },
    'sea-personaQuery9': {
        description: '"SMTP"',
    },
    'sea-personaQuery10': {
        description: 'SMTP',
    },
    'sea-personaQuery11': {
        description: 'from:(display name) / to:(display name)',
    },
    'sea-personaQuery12': {
        description: '"from:"display name" / to:"display name"',
    },
    'sea-personaQuery13': {
        description: '(display name)',
    },
    'sea-personaQuery14': {
        description: '“display name”',
    },
    'sea-personaQuery15': {
        description: 'display name',
    },
    'sea-personaQuery16': {
        description: '(KQL:(SMTP) OR KQL:(“Display Name”)) AND ("SMTP" OR "display name")',
    },
    'sea-pillHighlight': {
        description: 'Remove pill text from hit highlighting',
    },
    'sea-proxy3SQuery': {},
    'sea-qf': {},
    'sea-queryTextKQL': {
        description: 'Retain queryText from server suggestion for people pill KQL',
    },
    'sea-resultInstrumentation': {},
    'sea-searchBoxInteractions1': {
        description: 'Treatment 1 for search box interactions experiment',
    },
    'sea-searchBoxInteractionsClear': {
        description: 'Gates the clear search box button visiblity',
    },
    'sea-searchHistoryApi': {
        description:
            "If enabled, we'll make requests to new SearchHistory API when deleting/exporting search history.",
    },
    'sea-sendPillDisplayText': {
        description:
            'Prepends pills (using their DisplayText) to the query text sent in suggestions calls.',
    },
    'sea-skipOwsPrime': {},
    'sea-slashCommands': {
        description: 'Allows for slash commands inside of the Search Box.',
    },
    'sea-spellingCorrectedSearch': {
        description: 'Shows suggestions for misspelled search queries.',
    },
    'sea-substrateQuery': {},
    'sea-upscope': {
        description: 'Upscope link to M365 Search.',
    },
    'sea-zinq-3s': {
        description: 'Fetch zero-input no-query suggestions from 3S.',
    },
    'sea-zinq-3sctr': {
        description:
            'Custom control for 3S powered zero input flight.  Sends a request to 3S to suggestions but renders local suggestions.',
    },
    'cal-time-panel': {},
    'todo-panel': {},
    'todo-drag-to-calendar': {},
    'todo-flagged-email-list': {},
    'tri-anchorMailboxHeader': {},
    'tri-archive-mailbox': {
        description: 'Archive Mailbox Feature to be used in owa-mail',
    },
    'tri-bulkActionNotification': {},
    'tri-copyItem': {
        description: 'enables list view copy item context menu item',
    },
    'tri-coupon-peek': {},
    'tri-customHoverActions': {
        description: 'Controls whether customized message quick options will be enabled',
    },
    'tri-density-controls': {
        description: 'Full, Simple, Compact option in density controls',
    },
    'tri-conversationView-folderTags': {
        description: 'Folder tags in conversation view',
    },
    'tri-disableDynamicFolderPane': {
        description: 'Disables dynamic folder pane expansion / collapse',
    },
    'tri-favoriteHeader': {},
    'tri-favoriteSearch': {},
    'tri-favorites-roaming': {
        description: 'Enables Roaming favorites served from Prime endpoint.',
    },
    'tri-filterMenuRedesign': {
        description: 'Redesigned filter / sort menu',
    },
    'tri-flag-complete': {
        description: 'Show flag complete menu in list view right click menu',
    },
    'tri-folderPermissions': {
        description: 'Add folder permissions feature',
    },
    'tri-inbox-plus-v1': {
        description: 'Inbox plus feature in owa-mail',
    },
    'tri-moveToSweepOption': {
        description: 'Allows user to initiate sweep from moveTo menu',
    },
    'tri-moduleSwitcherBehavior': {
        description: 'Open workload in same tab instead of new tab',
    },
    'tri-notificationBar': {
        description: 'Show notifications for specific triage actions (move/archive/delete)',
    },
    'tri-pauseInbox': {
        description: 'Stop incoming mail from coming into inbox',
    },
    'tri-persistSort': {
        description: 'Persisting sort order per folder based on JSMVVM settings',
    },
    'tri-reportAbuse': {
        description: 'Adds report abuse action to ListView and ReadingPane drop down',
    },
    'tri-retentionPolicies': {
        description: 'Adds triage action of assigning policy for folders, mail items',
    },
    'tri-runRulesNow': {
        description: 'Adds option to run rule now from rule creation and rules option',
    },
    'tri-scrollMoreDataPoint': {
        description: 'Logging to determine how far users scroll down list view',
    },
    'tri-searchBackstacking': {
        description: 'Fixing search backstacking',
    },
    'tri-sharedFolders': {
        description: 'Add shared folders feature',
    },
    'tri-smartMergeFindResponse': {
        description:
            'Merges the FindConv/FindItem with the cached response data only if the lastModifiedTime changed',
    },
    'tri-snooze': {
        description: 'Adds snooze feature to delay message delivery.',
    },
    'tri-snooze-exp': {
        description: 'Adds snooze string for experiments.',
    },
    'tri-spamV2': {
        description: 'Controls Reporting and Filtering spam v2 settings',
    },
    'tri-spamV2SenderDomain': {
        description: 'Controls blocked/safe senders and domains spam v2 settings',
    },
    'tri-superJunkSettings': {
        description: 'Adds additional functionality to the junk options page and notifications',
    },
    'tri-suppressMarkReadBehaviorOnRF': {
        description: 'When enabled we shall suppress the mark read server behavior upon r/R/F',
    },
    'tri-sweepBulkAction': {
        description:
            'Controls whether bulk actions payloads will be sent from the server for sweep',
    },
    'tri-turnOffFocusedOther': {
        description: 'Adds a dialog in the mail list header to prompt user to turn off FO',
    },
    'tri-autoMarkReadInUnreadSetting': {
        description: 'Adds setting to support auto mark as read in the unread filter',
    },
    'tri-upNext': {},
    'tri-virtualizedListView': {
        description: 'Remove the inner divs of mail list item when item is scrolled out of view',
    },
    'usv-forum': {},
    'usv-nps': {},
    'whatsNew-AddFlairWithExpressions': {},
    'whatsNew-ConnectToLinkedIn': {},
    'whatsNew-DarkMode': {},
    'whatsNew-FilesHub': {},
    'whatsNew-NonPremiumEncryptEmail': {},
    'whatsNew-Pane': {},
    'whatsNew-PremiumAdvancedSecurity': {},
    'whatsNew-PremiumDashboard': {},
    'whatsNew-PremiumEncryptEmail': {},
    'whatsNew-ScheduleAtGlance': {},
    'whatsNew-SmartSearch': {},
    'whatsNew-AddCloudCacheAccount': {},
};

export default features;
export type FeatureName = Extract<keyof typeof features, string>;
